interface SectionHeadingProps {
  index: string;
  label: string;
  title: string;
  desc: string;
}

export default function SectionHeading({ index, label, title, desc }: SectionHeadingProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 pb-6 border-b border-background-300">
      <div className="flex items-start gap-4">
        <span className="font-label text-3xl md:text-4xl text-primary-500 leading-none pt-1">
          {index}
        </span>
        <div>
          <span className="font-label text-[11px] tracking-[0.2em] uppercase text-accent-700">
            {label}
          </span>
          <h4 className="mt-1.5">
            <a
              href="#top"
              className="font-heading font-bold text-xl md:text-2xl text-foreground-950 cursor-pointer"
            >
              {title}
            </a>
          </h4>
        </div>
      </div>
      <p className="text-sm text-foreground-600 max-w-xl md:text-right leading-relaxed">
        {desc}
      </p>
    </div>
  );
}